// src/components/CookieBanner.js
import React, { useState, useEffect } from "react";
import "../styles/cookiebanner.css";

const CookieBanner = ({ onPrivacyClick }) => {
  const [showBanner, setShowBanner] = useState(false);

  const checkAndShowBanner = () => {
    // Provjeri je li korisnik već prihvatio kolačiće
    const cookieConsent = localStorage.getItem("cookieConsent");
    // Provjeri je li prošao age restriction (prvo localStorage, zatim sessionStorage)
    const ageRestrictionLocal = localStorage.getItem("ageRestriction");
    const ageRestrictionSession = sessionStorage.getItem("ageRestriction");
    const ageRestriction = ageRestrictionLocal || ageRestrictionSession;
    
    // Prikaži banner samo ako je prošao age restriction i nije prihvatio kolačiće
    if (ageRestriction === "confirmed" && !cookieConsent) {
      // Dodaj malu pauzu nakon age restrictiona
      setTimeout(() => {
        setShowBanner(true);
      }, 500);
    }
  };

  useEffect(() => {
    // Provjeri odmah pri mountu
    checkAndShowBanner();

    // Slušaj custom event kada je age restriction potvrđen
    const handleAgeRestrictionConfirmed = () => {
      checkAndShowBanner();
    };

    window.addEventListener("ageRestrictionConfirmed", handleAgeRestrictionConfirmed);

    // Slušaj promjene u storage-u (za slučaj da se promijeni u drugom tabu)
    const handleStorageChange = (e) => {
      if (e.key === "ageRestriction" || e.key === "cookieConsent") {
        checkAndShowBanner();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("ageRestrictionConfirmed", handleAgeRestrictionConfirmed);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner-overlay">
      <div className="cookie-banner">
        <div className="cookie-banner-content">
          <h3 className="cookie-banner-title">Kolačići (Cookies)</h3>
          <p className="cookie-banner-text">
            Ova web stranica koristi kolačiće kako bismo vam pružili najbolje 
            korisničko iskustvo. Nastavkom korištenja stranice pristajete na 
            korištenje kolačića. Više informacija možete pronaći u našoj{" "}
            <button 
              className="cookie-banner-link" 
              onClick={onPrivacyClick}
            >
              politici privatnosti
            </button>.
          </p>
        </div>
        <div className="cookie-banner-actions">
          <button
            className="cookie-banner-btn cookie-banner-btn--accept"
            onClick={handleAccept}
          >
            Prihvati
          </button>
          <button
            className="cookie-banner-btn cookie-banner-btn--decline"
            onClick={handleDecline}
          >
            Odbij
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;

